import React from "react";
import { Helmet } from "react-helmet";
import { colors, serif } from "../../theme/brand";
import useMediaQuery from "../../hooks/useMediaQuery";

export default function AppContact() {
  const isMobile = useMediaQuery("(max-width: 860px)");

  return (
    <div style={{ animation: "fadeUp .5s ease both" }}>
      <Helmet>
        <title>Contact — Datails</title>
        <meta
          name="description"
          content="Vertel ons over je project. Technisch leiderschap, een platform bouwen of het juiste team samenstellen — stuur ons een mail en we plannen snel een kennismaking."
        />
      </Helmet>

      <section style={{ maxWidth: 1120, margin: "0 auto", padding: isMobile ? "56px 24px" : "100px 32px" }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 36 : 56, alignItems: "start" }}>
          <div>
            <p style={{ fontSize: 14, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: colors.teal, marginBottom: 16 }}>
              Contact
            </p>
            <h1 style={{ fontFamily: serif, fontWeight: 400, fontSize: "clamp(40px,5.5vw,72px)", lineHeight: 1.02, letterSpacing: "-0.015em", textWrap: "balance" }}>
              Vertel ons over
              <br />
              je project.
            </h1>
            <p style={{ fontSize: 19, lineHeight: 1.6, color: colors.text, marginTop: 26, maxWidth: 460 }}>
              Of het nu gaat om een AI-platform, technisch leiderschap, een cloud- of backendplatform of het juiste team — stuur ons
              een mail en we plannen snel een kennismaking.
            </p>
            <a
              href="mailto:info@datails.nl"
              style={{ display: "inline-flex", alignItems: "center", gap: 10, background: colors.teal, color: "#FBF7EF", padding: "16px 30px", borderRadius: 999, fontSize: 17, fontWeight: 600, marginTop: 34 }}
            >
              info@datails.nl
            </a>
          </div>
          <div style={{ border: `1px solid ${colors.border}`, borderRadius: 18, overflow: "hidden", background: colors.cream }}>
            <div style={{ padding: "32px 34px", borderBottom: `1px solid ${colors.border}` }}>
              <p style={{ fontSize: 13.5, fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase", color: colors.textFaint, marginBottom: 10 }}>
                E-mail
              </p>
              <a href="mailto:info@datails.nl" style={{ fontSize: 22, fontWeight: 600, color: colors.ink }}>
                info@datails.nl
              </a>
            </div>
            <div style={{ padding: "32px 34px", borderBottom: `1px solid ${colors.border}` }}>
              <p style={{ fontSize: 13.5, fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase", color: colors.textFaint, marginBottom: 10 }}>
                Locatie
              </p>
              <p style={{ fontSize: 19, color: colors.ink }}>Arnhem, Nederland</p>
              <p style={{ fontSize: 16, color: colors.textMuted, marginTop: 4 }}>Remote & op locatie in heel Nederland</p>
            </div>
            <div style={{ padding: "32px 34px" }}>
              <p style={{ fontSize: 13.5, fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase", color: colors.textFaint, marginBottom: 10 }}>
                Mobiel
              </p>
              <p style={{ fontSize: 19, color: colors.ink, display: "inline-flex", alignItems: "center", gap: 9 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#5C8A6A", display: "inline-block" }} />
                0611770007
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
